import { lazyRouteComponent } from '@tanstack/react-router';

export const dashboardPageLoadable = lazyRouteComponent(() =>
  import('../../ui/dashboard-page').then((m) => ({
    default: m.DashboardPage,
  })),
);
